import React from 'react';
import { Grid, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@mui/material';
import Loader from 'utils/Loader';
import SalesPerformanceReportController from 'pages/Controller/SalesPerformanceReportController';
import Select from 'react-select';

function SalesPerformanceReport() {
  const {
    data,
    cloading,
    totalRecords,
    page,
    setPage,
    pageSize,
    customerOptions,
    searchCustomer,
    selectedCustomerOption,
    setSelectedCustomerOption,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    detailDialogOpen,
    selectedSPId,
    detailRows,
    detailLoading,
    downloadLoading,
    handleClearFilters,
    handleDownloadReport,
    handleOpenDetails,
    handleCloseDetails
  } = SalesPerformanceReportController();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const selectStyles = {
    control: (provided) => ({ ...provided, backgroundColor: '#fff' }),
    menu: (provided) => ({ ...provided, zIndex: 1400 })
  };

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading ? (
        <div className="overlay">
          <Loader />
        </div>
      ) : null}

      <div className="cutrange">
        <span className="font20">SALES ORDER PERFORMA</span>
      </div>

      <Box sx={{ p: 2, backgroundColor: '#fff', border: '1px solid #e6e6e6', borderRadius: 1 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3} md={3}>
            <Select
              options={customerOptions}
              value={selectedCustomerOption}
              onChange={(v) => setSelectedCustomerOption(v)}
              onInputChange={(inputValue) => {
                if (inputValue.length >= 3) {
                  searchCustomer(inputValue);
                }
              }}
              styles={selectStyles}
              placeholder="Select Customer"
              isClearable
            />
          </Grid>

          <Grid item xs={6} sm={3} md={3}>
            <TextField
              fullWidth
              label="From Date"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>

          <Grid item xs={6} sm={3} md={3}>
            <TextField
              fullWidth
              label="To Date"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>

          <Grid
            //  item xs={12} sm={3} md={3} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}
            item
            container
            xs={12}
            sm={3}
            md={3}
            // sx={{
            //   display: 'flex',
            //   alignItems: 'center',
            //   gap: 1
            // }}
          >
            <Grid item xs={12} sm={6} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>

              <Button
                variant="outlined"
                onClick={handleClearFilters}
                sx={{ backgroundColor: '#fff', color: '#d32f2f', borderColor: '#d32f2f', '&:hover': { backgroundColor: '#fff' } }}
              >
                Clear
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" onClick={handleDownloadReport} disabled={downloadLoading} sx={{ ml: 1 }}>
                {downloadLoading ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
                Download
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ pt: 2 }}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>SP ID</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Conference</TableCell>
                <TableCell>Distributor</TableCell>
                <TableCell>Retailer</TableCell>
                <TableCell>Order Number</TableCell>
                <TableCell>Sales Order Performa Quantity</TableCell>
                <TableCell>Order Quantity</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.length ? (
                data.map((row, idx) => (
                  <TableRow key={`${row.salesPerformerId}_${idx}`} hover>
                    <TableCell>
                      <span
                        style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => handleOpenDetails(row.salesPerformerId)}
                      >
                        {`SP-${row.salesPerformerId}`}
                      </span>
                    </TableCell>
                    <TableCell>{row.customerName}</TableCell>
                    <TableCell>{row.name || ''}</TableCell>
                    <TableCell>{row.distributorName || ''}</TableCell>
                    <TableCell>{row.retailerName || ''}</TableCell>
                    <TableCell>{row.orderNumber || ''}</TableCell>
                    <TableCell>{row.salesPerformerQuantity || ''}</TableCell>
                    <TableCell>{row.orderQuantity || ''}</TableCell>
                    <TableCell>{row.createdAt || ''}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={totalRecords || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          rowsPerPageOptions={[pageSize]}
          sx={{ backgroundColor: '#fff', '& .MuiTablePagination-displayedRows': { color: '#000' } }}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
        />
      </Box>

      <Dialog
        open={detailDialogOpen}
        onClose={handleCloseDetails}
        fullWidth
        maxWidth="xl"
        sx={{
          '& .MuiDialog-container': {
            justifyContent: { xs: 'center', md: 'flex-start' }
          },
          '& .MuiDialog-paper': {
            width: { xs: 'calc(100% - 32px)', md: 'calc(100% - 250px - 64px)' },
            maxWidth: { xs: 'calc(100% - 32px)', md: 'none' },
            ml: { xs: 2, md: 'calc(250px + 32px)' },
            mr: { xs: 2, md: 4 }
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>{`SP ID - ${selectedSPId}`}</DialogTitle>
        <DialogContent dividers sx={{ pr: { xs: 2, sm: 4 } }}>
          {detailLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <Loader />
            </Box>
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Barcode</TableCell>
                    <TableCell align="center">Material Code</TableCell>
                    <TableCell align="center">Main Group</TableCell>
                    <TableCell align="center">Material Desc</TableCell>
                    <TableCell align="center">Quantity</TableCell>
                    <TableCell align="center">Barcode Order Quantity</TableCell>
                    <TableCell align="center">Shade</TableCell>
                    <TableCell align="center">Created At</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {detailRows && detailRows.length ? (
                    detailRows.map((row, idx) => (
                      <TableRow key={`${row.barcode || idx}_${idx}`} hover>
                        <TableCell align="center">{row.barcode || ''}</TableCell>
                        <TableCell align="center">{row.materialCode || ''}</TableCell>
                        <TableCell align="center">{row.mainGroup || ''}</TableCell>
                        <TableCell align="center">{row.materialDesc || ''}</TableCell>
                        <TableCell align="center">{row.quantity || ''}</TableCell>
                        <TableCell align="center">{row.barcodeOrderQuantity || ''}</TableCell>
                        <TableCell align="center">{row.shade || ''}</TableCell>
                        <TableCell align="center">{row.createdAt || ''}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No detail records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetails}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SalesPerformanceReport;
